import { DollarSign } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../../../components/ui/card';
import { AntecipacaoResponse } from '../types';

interface AntecipacaoSummaryCardsProps {
  summary: AntecipacaoResponse['summary'];
  formatCurrency: (value: number) => string;
}

export function AntecipacaoSummaryCards({
  summary,
  formatCurrency,
}: AntecipacaoSummaryCardsProps) {
  return (
    <div className="grid gap-4 md:grid-cols-2">
      <Card className="bg-white border-[hsl(214,32%,91%)] shadow-sm">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium text-[hsl(210,50%,10%)]">
            Valor Face Acumulado
          </CardTitle>
          <DollarSign className="h-4 w-4 text-[hsl(215,16%,47%)]" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-[hsl(142,76%,36%)]">
            {formatCurrency(summary.valorFace)}
          </div>
        </CardContent>
      </Card>

      <Card className="bg-white border-[hsl(214,32%,91%)] shadow-sm">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium text-[hsl(210,50%,10%)]">
            Valor Compra Acumulado
          </CardTitle>
          <DollarSign className="h-4 w-4 text-[hsl(215,16%,47%)]" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold text-[hsl(210,35%,32%)]">
            {formatCurrency(summary.valorCompra)}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
